import { useEffect } from 'react';
import { MessagesContainer } from '../state/messages';
import { useTranslation } from '../i18n/i18n';

export function useRedirectAlerts() {
	const globalAlerts = MessagesContainer.useContainer();
	const t = useTranslation().alerts;
	useEffect(() => {
		if (document.location.hash == '#rfp') {
			globalAlerts.add({ message: t.redirectedFromProduct, type: 'warning' });
		}
	}, []);
}
